export enum TablasDispositivos {
  Computer = 'Computer',
  NetworkEquipment = 'NetworkEquipment',
  Printer = 'Printer',
  Monitor = 'Monitor',
  Peripheral = 'Peripheral',
  Rack = 'Rack',
  Phone = 'Phone',
  Todos = 'AllAssets',

  // Otros tipos
  Manufacturer = 'Manufacturer',
}
